import { Box, styled } from '@mui/material';

export const BundleCourseCardStyle = styled(Box)(
  ({ theme }) => `
  border-radius: 10px;
  display: flex;
  flex-direction: row;
  box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);
  position: relative;

  ${theme.breakpoints.down('md')} {
    box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0);
    margin-bottom: 0px;
    border-radius: 0px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  }


  .course-card-detail-box {
    width: 966px;
    justify-content: start;
    align-items: start;
    display: flex;
    flex-direction: row;
    padding: 24px 0 24px 24px;

    ${theme.breakpoints.down('lg')} {
      width: 558px;
    }

    ${theme.breakpoints.down('md')} {
      width: 100%;
      padding: 16px 0px;
    }
  }

  .course-card-image-box {
    gap: 40px;
    display: flex;
    flex-direction: row;
    height: 150px;

    .image {
      width: 257px;
      height: 150px;
      ${theme.breakpoints.down('md')} {
        width: 123px;
        height: 71px;
        margin-left: 0px;
        border: 1px solid #eeeeee;
        border-radius: 8px;
      }
    }

    ${theme.breakpoints.down('md')} {
      margin-left: 0px;
      height: 71px;
      align-items: start;
    }

  }

  .course-card-no-box {
    width: 83px;
    height: 86px;
    padding: 0px 24px;
    gap: 8px;
    align-items: center;
    align-self: center;
    display: flex;
    flex-direction: column;

    @media only screen and (max-width: 1199px) {
      display: none;
      width: 0px;
    }
  }

  .course-card-info-box {
    width: 546px;
    height: 100%;
    margin-left: 40px;
    display: flex;
    flex-direction: column;
    justify-content: start;

    .course-title {
      ${theme.breakpoints.down('md')} {
        font-size: 14px;
        font-weight: 500;
        line-height: 14px;
      }
    }

    @media only screen and (max-width: 1199px) and (min-width: 768px) {
      margin-left: 24px;
    }

    @media only screen and (max-width: 767px) {
      margin-left: 16px;
      align-self: center;
    }
  }

  .course-card-instructors-info-box {
    display: flex;
    flex-direction: row;
  }

  .course-card-enrolled-box {
    width: 107px;
    height: 28px;
    background-color: ${theme.palette.success.main};
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 24px;
    margin-top: auto;

    ${theme.breakpoints.down('md')} {
      background-color: unset;
      display: unset;
      height: unset;

      .enrolled-title {
        font-size: 14px;
      }
    }

  }

  .ribbon-certificate-box {
    position: absolute;
    right: 0px;
    left: auto;
    margin-top: 24px;

    ${theme.breakpoints.down('md')} {
      position: absolute;
      left: 0px;
      right: auto;
      margin-top: 16px;
    }
  }
`,
);
